import { Injectable, Input } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { EnvService } from './../services/env.service';
import { asLiteral } from '@angular/compiler/src/render3/view/util';
import { Observable, observable, of } from "rxjs";
// import { ProjectService } from './project.service';
// import { CommonObject } from './common-object';
// import { getBusinessTimeResponse, getBusinessTimeResponseVizDate, getBusinessTimeResponseVizDateTime } from '../dce-views/procedure/procedure-interface';
import { isArray } from 'util';
import { ToastrService } from 'ngx-toastr';
import { ToastrUtilityService } from './toastr-utility.service';
declare var $: any;

@Injectable({
	providedIn: 'root'
})
export class CommonService  {
// export class CommonService extends ProjectService {
	lambda = {
		'equal': function(op1,op2){ return op1 == op2} ,
		'not_equal': function(op1,op2){ return op1 != op2} ,
		'less': function(op1,op2){ return op1 < op2} ,
		'less_or_equal': function(op1,op2){ return op1 <= op2} ,
		'greater': function(op1,op2){ return op1 > op2} ,
		'greater_or_equal': function(op1,op2){ return op1 >= op2} ,
		'in': function(op1,op2){ return $.inArray(op2,op1) !== -1} ,
		'not_in': function(op1,op2){ return $.inArray(op2,op1) === -1} ,
		'is_not_null': function(op1,op2){ return (op1 != undefined && op1 != null)} ,
		'is_null': function(op1,op2){ return (op1 == undefined || op1 == null)} ,
		'is_empty': function(op1){ return (op1 == null || op1 == '')} ,
	}
	final_string : string;
	field_map = {};
	operator_map = {
		"equal": "equal",
		"is_not_null": "is not null",             
		"is_null": "is null",             
		"not_equal": "not equal",             
		"less": "less",             
		"less_or_equal": "less or equal",             
		"greater": "greater",             
		"greater_or_equal": "greater or equal",             
		"contains": "contains",             
		"in": "in",             
		"not_contains": "doesn't contain",             
		"not_in": "not in",             
		"begins_with": "begins with",             
		"ends_with": "ends with",             
		"not_begins_with": "doesn't begin with",             
		"not_ends_with": "doesn't end with",
		"between": "between",
		"is_empty": "is empty",
		"is_not_empty": "is not empty",
		"not_between": "not between"
	};
	constructor(
		protected http: HttpClient,
		// protected comObj: CommonObject,
		protected env: EnvService,
		private _toastr: ToastrService,
		private _toastrUtility: ToastrUtilityService
	) { 
		// tslint:disable-next-line:indent
		// super(http, env);
	}

	private get_intent_response_url = `${this.env.service_url}/get_intent_response`;
	get_intent_response(payload) {
		return this.http.post<any>(this.get_intent_response_url, payload);
	}

	private get_persist_and_command_options_url = `${this.env.service_url}/get_persist_and_command_options`;
	get_persist_and_command_options(payload) {
		return this.http.post<any>(this.get_persist_and_command_options_url, payload);
	}

	private get_intent_response_for_demo_url = `${this.env.service_url}/demo/chat`;
	get_intent_response_for_demo(payload) {
		return this.http.post<any>(this.get_intent_response_for_demo_url, payload);
	}

	private get_persist_and_command_options_for_demo_url = `${this.env.service_url}/demo/get_persist_and_command_options`;
	get_persist_and_command_options_for_demo(payload) {
		return this.http.post<any>(this.get_persist_and_command_options_for_demo_url, payload);
	}

	private export_chat_url = `${this.env.service_url}/chat/export/get`;
	export_chat(payload) {
		return this.http.post<any>(this.export_chat_url, payload);
	}

	private create_api_definition_url = `${this.env.service_url}/create_api_definition`;
	create_api_definition = (payload) => {
		return this.http.post<any>(this.create_api_definition_url, payload);
	}

	private update_api_definition_url = `${this.env.service_url}/update_api_definition`;
	update_api_definition = (payload) => {
		return this.http.post<any>(this.update_api_definition_url, payload);
	}

	private delete_api_definition_url = `${this.env.service_url}/delete_api_definition`;
	delete_api_definition = (payload) => {
		return this.http.post<any>(this.delete_api_definition_url, payload);
	}

	private get_api_definition_url = `${this.env.service_url}/get_api_definition`;
	get_api_definition = (payload) => {
		return this.http.post<any>(this.get_api_definition_url, payload);
	}

	private get_all_api_definitions_url = `${this.env.service_url}/get_all_api_definitions`;
	get_all_api_definitions = (payload) => {
		return this.http.post<any>(this.get_all_api_definitions_url, payload);
	}

	private test_api_url = `${this.env.service_url}/test_api`;
	test_api = (payload) => {
		return this.http.post<any>(this.test_api_url, payload);
	}

	private update_encrypted_header_value_url = `${this.env.service_url}/notification_api_definition/update/encrypted`;
	update_encrypted_header_value = (payload) => {
		return this.http.post<any>(this.update_encrypted_header_value_url, payload);
	}

	//  app registry CRUD APIs
	private create_app_registry_url = `${this.env.service_url}/app/create`;
	create_app_registry(payload) {
		return this.http.post<any>(this.create_app_registry_url, payload);
	}

	private update_app_registry_url = `${this.env.service_url}/app/update`;
	update_app_registry(payload) {
		return this.http.post<any>(this.update_app_registry_url, payload);
	}

	private remove_app_registry_url = `${this.env.service_url}/app/remove`;
	remove_app_registry(payload) {
		return this.http.post<any>(this.remove_app_registry_url, payload);
	}

	private get_all_apps_url = `${this.env.service_url}/app/get_all`;
	get_all_apps(payload) {
		return this.http.post<any>(this.get_all_apps_url, payload);
	}	

	private replace_token_in_app_url = `${this.env.service_url}/app/replace/token`;
	replace_token_in_app(payload) {
		return this.http.post<any>(this.replace_token_in_app_url, payload);
	}

	// App Accounts APIs
	private create_app_account_url = `${this.env.service_url}/app/account/create`;
	create_app_account(payload) {
		return this.http.post<any>(this.create_app_account_url, payload);
	}
	private update_app_account_url = `${this.env.service_url}/app/account/update`;
	update_app_account(payload) {
		return this.http.post<any>(this.update_app_account_url, payload);
	}
	private remove_app_account_url = `${this.env.service_url}/app/account/remove`;
	remove_app_account(payload) {
		return this.http.post<any>(this.remove_app_account_url, payload);
	}
	private get_all_app_accounts_url = `${this.env.service_url}/app/account/get_all`;
	get_all_app_accounts(payload) {
		return this.http.post<any>(this.get_all_app_accounts_url, payload);
	}

	// Common Functions

	get_request_formatter(url, payload) {
		const req = `${url}?${this.convert_dict_to_param(payload)}`;
		return req;
	}

	convert_dict_to_param(payload) {
		let query_param = "";
		for (let key in payload) {
		query_param += key + "=" + payload[key] + '&'
		}
		return query_param.slice(0, -1);
	}

	process_get_req(route, payload) {
		return `${route}?${this.object_to_query_param(payload)}`;
	}
	object_to_query_param(obj) {
		let query_param = "";
		for (let key in obj) {
		query_param += key + "=" + obj[key] + '&'
		}
		return query_param.slice(0, -1)
	}

	//replace_empty_values
	replace_empty_values(res, keys, replace_with) {

		for(let i=0;i<res.length;i++){
			for(var j=0; j<keys.length; j++){
				if(res[i][keys[j]] == '' || res[i][keys[j]] == null){
					res[i][keys[j]] = replace_with;
				}
			}
		}

		return res;

	}

	filter_data_in_datatable(val, column_list, data) {

		let data_list = [];
		if (val) {
			val = val.trim().toLowerCase();
		} else {
			return data_list = [...data];
		}

		if (!column_list.length) {
			return;
		}

		const rows = data.filter(function (d) {
			for (let i = 0; i <= column_list.length; i++) {
				const column = column_list[i];
				if (d[column] && d[column].toString().toLowerCase().indexOf(val) > -1) {
					return true;
				}
			}
		});
		data_list = rows;
		return data_list;
	}

	date_formatter(event){
		let new_date = '';
		for ( var key in event) {
			if (key == 'day') {
			new_date+= event[key];
			} else  if (key == 'month' || key == 'year'){
			new_date+= event[key]+ '-';
			}
		}
		return new_date;
	}

	date_validation(start_date, end_date) {
		const sdate = new Date(start_date);
		const edate = new Date(end_date);
		return (sdate.getTime() < edate.getTime()) ? true : false;
	}

	date_validation_eq(start_date, end_date) {
		const sdate = new Date(start_date);
		const edate = new Date(end_date);
		return (sdate.getTime() <= edate.getTime()) ? true : false;
	}


	qry_builder_decision_to_backend_old(decision_data, data_type_map){
		var condition_map = {
			"AND": 'and',
			"OR": 'or',
			"NOT": 'not'
		};

		var operator_map = {
			"equal": '==',
			"not_equal": '!=',
			"less": '<',
			"less_or_equal": '<=',
			"greater": '>',
			"greater_or_equal": '>=',
			"is_null":"is_null",
			"is_not_null":"is_not_null",
			'in':'in',
			'not_in':'not_in',
			// 'between':'between',
			// 'not_between':'not_between',
			// 'begins_with':'begins_with',
			// 'not_begins_with':'not_begins_with',
			'contains':'contains',
			'not_contains':'not_contains',
			// 'ends_with':'ends_with',
			// 'not_ends_with':'not_ends_with',
			// 'is_empty':'is_empty',
			// 'is_not_empty':'is_not_empty',
		};

		// console.log(decision_data);
		var ret_val = {};
		var temp_list = [];
		var condition = decision_data['condition'];
		var rules = decision_data['rules'];
		var ret = {};
		var final_list = [];
		var d_type = 'str';

		for(var i=0; i<rules.length; i++){
			if(rules[i]['condition'] != undefined){
				ret = this.qry_builder_decision_to_backend_old(rules[i], data_type_map);
			} else {
				d_type = "str";
				if(data_type_map[rules[i]['id']]){
					d_type = data_type_map[rules[i]['id']];
				}
				temp_list.push({
					"operator": operator_map[rules[i]['operator']],
					"type": "str",	//	not required
					"data_type": data_type_map[rules[i]['id']],
					"op1": rules[i]['id'],
					"op2": rules[i]['value']
				});
			}
		}
		if(!$.isEmptyObject(ret)){
			final_list = temp_list.concat(ret);
		} else {
			final_list = temp_list;
		}

		ret_val[condition_map[condition]] = final_list;
		// console.log(condition);
		// console.log(final_list);
		// console.log(ret_val);
		// console.log("-------");
		// debugger
		return ret_val;
	}

	qry_builder_decision_to_backend(decision_data, data_type_map){
		var condition_map = {
			"AND": 'and',
			"OR": 'or',
			"NOT": 'not'
		};

		var operator_map = {
			"equal": '==',
			"not_equal": '!=',
			"less": '<',
			"less_or_equal": '<=',
			"greater": '>',
			"greater_or_equal": '>=',
			"is_null":"is_null",
			"is_not_null":"is_not_null",
			'in':'in',
			'not_in':'not_in',
			'between':'between',
			'not_between':'not_between',
			'begins_with':'begins_with',
			'not_begins_with':'not_begins_with',
			'contains':'contains',
			'not_contains':'not_contains',
			'ends_with':'ends_with',
			'not_ends_with':'not_ends_with',
			'is_empty':'is_empty',
			'is_not_empty':'is_not_empty',
		};

		var ret_val = {};
		var obj = {};

		if(decision_data.condition != undefined){
			ret_val[condition_map[decision_data.condition]] = []
			for(var i=0; i<decision_data.rules.length; i++){
				obj = this.qry_builder_decision_to_backend(decision_data.rules[i], data_type_map)
				ret_val[condition_map[decision_data.condition]].push(obj)
			}
			return ret_val;

		} else {
			return {
				"operator": operator_map[decision_data['operator']],
				"type": "str",	//	not required
				"data_type": data_type_map[decision_data['id']],
				"op1": decision_data['id'],
				"op2": decision_data['value']
			}
		}
	}
	
	//Quote To RFQ Workgroup Relation
	private add_rfq_to_quote_workgroup_url = `${this.env.service_url}/add_rfq_to_quote_workgroup`;
	add_rfq_to_quote_workgroup(payload) {
		return this.http.post<any>( this.add_rfq_to_quote_workgroup_url, payload);
	}
	private get_rfq_quote_map_url = `${this.env.service_url}/get_rfq_quote_map`;
	get_rfq_quote_map() {
		return this.http.post<any>( this.get_rfq_quote_map_url,{});
	}
	process_rule(decision_data,object_data,user_id){
		// console.log(this.lambda['equal'](1,2));
		let ret_val = true;
		let temp_list = [];
		let condition = decision_data['condition'];
		let rules = decision_data['rules'];

		for(let i=0; i<rules.length; i++){
			if(rules[i]['condition'] != undefined){
				temp_list.push(this.process_rule(rules[i],object_data,user_id));
			} else {
				if(rules[i]['id'] == "DCE_SPECIAL_KEY"){
					temp_list.push(this.process_dce_special_key(rules[i],user_id,object_data))
				}else{
					temp_list.push(this.lambda[rules[i]['operator']](object_data[rules[i]['id']],rules[i]['value']));
				}	
			}
		}
		for (let index = 0; index < temp_list.length; index++) {
			if(condition == "AND"){
				if(!temp_list[index]){
					ret_val =  false
					break;
				}else{
					ret_val =  true
				}
			}
			if(condition == "OR"){
				if(temp_list[index]){
					ret_val =  true
					break;
				}else{
					ret_val =  false
				}
			}				
		}
		return ret_val;
	}	
	process_dce_special_key(rule,user_id,object_data){
		if(rule['value']){
			let op = rule['value'].split('$$')
			if(op[1] == 'user_id'){
				return this.lambda[rule['operator']](object_data[op[0]],user_id);
			} else if (op[1] =='today')  {
				const today_string = this.formatDate(new Date());
				return this.lambda[rule['operator']](object_data[op[0]],today_string);
			}
		}
		return false;
	}
	onSortDT(event,data){
		const rows = [...data];
		const sort = event.sorts[0];
		rows.sort((a, b) => {
			return a[sort.prop].localeCompare(b[sort.prop]) * (sort.dir === 'desc' ? -1 : 1);
		});
		return rows
	}

	sortByKey(array, key, order) {
		return array.sort(function(a, b) {
			var x = a[key]; var y = b[key];
			// if(x<y) {
			// 	return order == 'asc'? -1: 1
			// } else if (x>y) {
			// 	return order == 'asc'? 1: -1
			// } else {
			// 	return 0;
			// }
			if (order == 'asc') {
				return ((x < y) ? -1 : ((x > y) ? 1 : 0));
			} else if (order == 'desc') {
				return ((x < y) ? 1 : ((x > y) ? -1 : 0));
			}
		});
	}

		// Pass data in array e.g ['select', 'input', 'textarea'];
	add_title_attribute(tag_list) {
		const html_tags = {
			'input': function(){
					$("input").each(function(){
						$(this).attr("title", $(this).val());
					});
			},
			'textarea': function() { 
					$("textarea").each(function(){
						$(this).attr("title", $(this).val());
					});
			},
			'select': function(){	
					$("select").each(function(){
						$(this).attr("title", $(this).find(":selected").text());
					});
			}
		}
		for(let i = 0;i< tag_list.length; i++) {
			setTimeout(() => {
				html_tags[tag_list[i]]();
			}, 200);
		}

	}
	onChanged($event){
		setTimeout(function(){
			if(!$('.autocomplete-container').hasClass('active')){
			$('.suggestions-container').hide()
			$('.not-found').hide()
			}else{
			$('.suggestions-container').show()
			$('.not-found').show()
			}
		},10);
	}

	changeSortSettings(col,sort_type,_case) {
		localStorage.setItem(_case, JSON.stringify([{prop: col, dir: sort_type}]));
	}

	getSortSettings(_case) {
		if (localStorage.getItem(_case)) {
			return JSON.parse(localStorage.getItem(_case));
		}
	}

	formatDate(date) {
		var d = new Date(date),
				month = '' + (d.getMonth() + 1),
				day = '' + d.getDate(),
				year = d.getFullYear();

		if (month.length < 2) 
				month = '0' + month;
		if (day.length < 2) 
				day = '0' + day;

		return [year, month, day].join('-');
	}

	process_selected_advice(selected_plan){
		let show_payload= {
			'basic' : [
				{'label':'Member National Id','value':selected_plan.national_id},
				{'label':'Member Full Name','value':selected_plan.mem_full_name},
				{'label':'Cell phone','value':selected_plan.comm_phone},
				{'label':'Email Address','value':selected_plan.comm_email},
				// {'label':'Advice Id','value':selected_plan.advice_id},
			],
			'client_objectives':[],
			'need_filters':[],
		}

	}

	private send_forgot_password_email_url = `${this.env.service_url}/send_forgot_password_email`
	send_forgot_password_email(payload){
		return this.http.post<any>( this.send_forgot_password_email_url, payload);
	}

	private forgot_password_url  = `${this.env.service_url}/forgot_password`;
	forgot_password(payload){
		return this.http.post<any>( this.forgot_password_url, payload);
	}

	private check_password_availablity_url  = `${this.env.service_url}/check_password_already_used`;
	check_password_availablity(payload){
		return this.http.post<any>( this.check_password_availablity_url, payload);
	}

	private _get_internal_user_details_refresh_url = `${this.env.service_url}/get_internal_user_details_refresh`;
	get_data_after_refresh(payload) {
		return this.http.post<any>( this._get_internal_user_details_refresh_url, payload);
	}

	private get_user_role_map_url = `${this.env.service_url}/get_user_role_map`;
	get_user_role_map(payload) {
		return this.http.post<any>( this.get_user_role_map_url, payload);
	}

	public update_sidebar_configuration_url = `${this.env.service_url}/update_sidebar_configuration`;
	update_sidebar_configuration(payload) {
		return this.http.post<any>( this.update_sidebar_configuration_url, payload);
	}

	private get_component_configuration_url = `${this.env.service_url}/get_component_configuration`;
	get_component_configuration(payload) {
		return this.http.post<any>( this.get_component_configuration_url, payload);
	}

	public update_component_configuration_url = `${this.env.service_url}/update_component_configuration`;
	update_component_configuration(payload) {
		return this.http.post<any>( this.update_component_configuration_url, payload);
	}

	private get_all_user_roles_url = `${this.env.service_url}/get_all_user_roles`;
	get_all_user_roles(payload) {
		return this.http.post<any>( this.get_all_user_roles_url, payload);
	}

	private update_user_roles_url = `${this.env.service_url}/update_user_roles`;
	update_user_roles(payload) {
		return this.http.post<any>( this.update_user_roles_url, payload);
	}

	private get_roles_list_url = `${this.env.service_url}/get_all/role`;
	get_roles_list(payload) {
		return this.http.post<any>( this.get_roles_list_url, payload);
	}

	private _get_sidebar_configuration_url = `${this.env.service_url}/get_sidebar_configuration`;
	get_sidebar_configuration(payload) {
		return this.http.post<any>( this._get_sidebar_configuration_url, payload);
	}

	public create_new_role_url = `${this.env.service_url}/create/role`;
	create_new_role(payload) {
		return this.http.post<any>( this.create_new_role_url, payload);
	}

	private get_users_list_url = `${this.env.service_url}/user/get_all`;
	get_users_list(payload) {
		return this.http.post<any>(this.get_users_list_url, payload);
	}

	private get_all_user_role_v1_url = `${this.env.service_url}/role/users/get_all`;
	get_all_user_role_v1(payload) {
		return this.http.post<any>( this.get_all_user_role_v1_url, payload);
	}

	private deactivate_user_role_url = `${this.env.service_url}/deactivate_user_role`;
	deactivate_user_role(payload) {
		return this.http.post<any>( this.deactivate_user_role_url, payload);
	}

	private add_user_role_url = `${this.env.service_url}/add_user_role`;
	add_user_role(payload) {
		return this.http.post<any>( this.add_user_role_url, payload);
	}

	private add_multiple_user_role_url = `${this.env.service_url}/add_multiple_user_role`;
	add_multiple_user_role(payload) {
		return this.http.post<any>( this.add_multiple_user_role_url, payload);
	}

	private get_sidebar_tree_url = `${this.env.service_url}/get_sidebar_tree`;
	get_sidebar_tree(payload) {
		return this.http.post<any>( this.get_sidebar_tree_url, payload);
	}

	// User Crud
	private create_user_url = `${this.env.service_url}/user/create`;
	create_user(payload) {
		return this.http.post<any>( this.create_user_url, payload);
	}

	private remove_user_url = `${this.env.service_url}/user/remove`;
	remove_user(payload) {
		return this.http.post<any>( this.remove_user_url, payload);
	}

	private update_user_url = `${this.env.service_url}/user/update`;
	update_user(payload) {
		return this.http.post<any>( this.update_user_url, payload);
	}

	private get_all_users_url = `${this.env.service_url}/user/get_all`;
	get_all_users(payload) {
		return this.http.post<any>( this.get_all_users_url, payload);
	}

	private reset_password_url = `${this.env.service_url}/reset_password`
	reset_password(payload){
		return this.http.post<any>( this.reset_password_url, payload);
	}

	// components crud
	private create_component_url = `${this.env.service_url}/component/create`
	create_component(payload){
		return this.http.post<any>( this.create_component_url, payload);
	}

	private update_component_url = `${this.env.service_url}/component/update`
	update_component(payload){
		return this.http.post<any>( this.update_component_url, payload);
	}

	private remove_component_url = `${this.env.service_url}/component/remove`
	remove_component(payload){
		return this.http.post<any>( this.remove_component_url, payload);
	}

	private get_component_url = `${this.env.service_url}/component/get`
	get_component(payload){
		return this.http.post<any>( this.get_component_url, payload);
	}

	// private get_all_component_url = `${this.env.service_url}/component/get_all`
	// get_all_component(payload){
	// 	return this.http.post<any>( this.get_all_component_url, payload);
	// }


}